<div class="tab-group-wrapper">
	<div class="tab-group" [ngClass]="{ vertical: orientation() === 'vertical', horizontal: orientation() === 'horizontal' }">
		@for (tabItem of tabList(); track $index) {
			<div class="tab-item">
				<a [routerLink]="tabItem.routerLink" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{ exact: !!tabItem.exactMatch }">
					<span
						>{{ tabItem.linkText }}
						@if (tabItem.tagValue) {
							&nbsp;&nbsp;<md-tag type="tertiary">{{ tabItem.tagValue }}</md-tag>
						}
					</span>
				</a>
			</div>
		}
	</div>
	<div class="tab-actions">
		<ng-content select="[tab-actions]"></ng-content>
	</div>
</div>
